export const DATE_BY_ID: Record<string, Date> = {
    now: new Date(),
    pastThreeHours: new Date(new Date().setHours(new Date().getHours() - 3)),
    pastSixHours: new Date(new Date().setHours(new Date().getHours() - 6)),
    pastTwelveHours: new Date(new Date().setHours(new Date().getHours() - 12)),
    pastTwentyFourHours: new Date(new Date().setHours(new Date().getHours() - 24)),
    pastSevenDays: ((): Date => {
        const date = new Date();
        date.setDate(date.getDate() - 7);
        date.setHours(0, 0, 0, 0);
        return date;
    })(),
    nextThreeHours: new Date(new Date().setHours(new Date().getHours() + 3)),
    nextSixHours: new Date(new Date().setHours(new Date().getHours() + 6)),
    nextTwelveHours: new Date(new Date().setHours(new Date().getHours() + 12)),
    nextTwentyFourHours: new Date(new Date().setHours(new Date().getHours() + 24)),
    nextSevenDays: ((): Date => {
        const date = new Date();
        date.setDate(date.getDate() + 7);
        date.setHours(23, 0, 0, 0);
        return date;
    })(),
};

export const DATE_RANGE_BY_ID: Record<string, [Date, Date]> = {
    today: ((): [Date, Date] => {
        const start = new Date();
        start.setHours(0, 0, 0, 0);
        const end = new Date(start);
        end.setHours(23, 0, 0, 0);
        return [start, end];
    })(),

    tomorrow: ((): [Date, Date] => {
        const start = new Date();
        start.setDate(start.getDate() + 1);
        start.setHours(0, 0, 0, 0);
        const end = new Date(start);
        end.setHours(23, 0, 0, 0);
        return [start, end];
    })(),

    yesterday: ((): [Date, Date] => {
        const start = new Date();
        start.setDate(start.getDate() - 1);
        start.setHours(0, 0, 0, 0);
        const end = new Date(start);
        end.setHours(23, 0, 0, 0);
        return [start, end];
    })(),

    currentWeek: ((): [Date, Date] => {
        const now = new Date();
        const start = new Date(now);
        const dayOfWeek = start.getDay();
        const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
        start.setDate(start.getDate() + diffToMonday);
        start.setHours(0, 0, 0, 0);

        const end = new Date(start);
        end.setDate(start.getDate() + 6);
        end.setHours(23, 0, 0, 0);
        return [start, end];
    })(),

    currentMonth: ((): [Date, Date] => {
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        end.setHours(23, 0, 0, 0);
        return [start, end];
    })(),

    currentYear: ((): [Date, Date] => {
        const now = new Date();
        const start = new Date(now.getFullYear(), 0, 1);
        const end = new Date(now.getFullYear(), 11, 31);
        end.setHours(23, 0, 0, 0);
        return [start, end];
    })(),

    yearToDate: ((): [Date, Date] => {
        const now = new Date();
        const start = new Date(now.getFullYear(), 0, 1);
        const end = new Date();
        end.setHours(23, 0, 0, 0);
        return [start, end];
    })(),

    lastYear: ((): [Date, Date] => {
        const end = new Date();
        end.setHours(23, 0, 0, 0);
        const start = new Date(end);
        start.setFullYear(start.getFullYear() - 1);
        start.setHours(0, 0, 0, 0);
        return [start, end];
    })(),
};
